import { Injectable } from '@angular/core';
import * as mixpanel from 'mixpanel-browser';
import { AuthService } from './auth.service';
import { environment } from '../../../environments/environment';
import { User } from '../interfaces/user';

@Injectable({
  providedIn: 'root',
})
export class MixpanelService {
  isInitialized: boolean;
  constructor(private authService: AuthService) {}

  async init() {
    try {
      await mixpanel.init(environment.mixpanel.token);
      this.isInitialized = true;
    } catch (err) {
      this.isInitialized = false;
    }
  }

  async trackEvent(eventName: string, param: any) {
    if (!this.isInitialized) await this.init();
    if (this.isInitialized) await mixpanel.track(eventName, param);
  }
  async alias(user: User) {
    if (!this.isInitialized) await this.init();
    if (this.isInitialized) await mixpanel.alias(user.id);
  }
  async identify() {
    if (!this.isInitialized) await this.init();
    if (!this.isInitialized) return;
    const user = this.authService.getUser();
    const tenant = this.authService.getTenant();
    mixpanel.identify(user.id);
    mixpanel.people.set({
      firstName: user.firstName,
      lastName: user.lastName,
      $email: user.email,
      'Company Name': tenant.name,
      'Account Type': tenant.type,
      'Is Super Admin': tenant.isAdmin || user.isAdmin,
    });
  }
  async reset() {
    await mixpanel.reset();
  }
}
